import { Component, OnInit, ElementRef, EventEmitter, Output, Input } from '@angular/core';
import { APP_CONFIG } from '../config';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { Router } from '@angular/router';
import { UserService } from 'src/app/services/user-service/user.service';

@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss']
})
export class SidenavComponent implements OnInit {

  @Input() sidenavMobile: boolean;
  @Input() sidenavOpened: boolean;
  @Input() sidenavLocked: boolean;
  @Input() navbarHeight: number;
  @Input() footerHeight: number;
  @Output() sidenavOpenedEmitter: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() sidenavLockedEmitter: EventEmitter<boolean> = new EventEmitter<boolean>();
  sidenavAccountHeight = 250;

  expandDashboard = true;
  expandAudience = false;

  constructor(private userStorageService: UserStorageService,
              public router: Router,
            private userService: UserService) { }

  ngOnInit() {}

  public mouseoverBrand() {
    if ((!this.sidenavLocked) && (!this.sidenavOpened)) {
       this.sidenavOpenedEmitter.emit();
    }
  }
  public mouseleaveBrand() {
    if ((this.sidenavOpened) && (!this.sidenavLocked)) {
      this.sidenavOpenedEmitter.emit();
    }
  }

  public sidenavLockedReceiver() {
    this.sidenavLockedEmitter.emit();
  }

  public getSidenavUlHeight() {
    return window.innerHeight - this.navbarHeight - this.footerHeight - this.sidenavAccountHeight;
  }

  public closeMenu() {
    if (window.innerWidth < APP_CONFIG.responsiveWidth) {
      this.sidenavOpenedEmitter.emit();
    }
  }

  public goto(destiny) {
    this.router.navigate([destiny]);
  }

  public accessGranted(optionId) {
    return this.userService.accessGranted(optionId);
  }

}
